export enum CenterOpenState {
    CENTER_OPENING_CHECKLIST = "center_opening_checklist",
    CENTER_OPEN = "center_open",
    CENTER_OPEN_SERVICE_CLOSED = "center_open_service_closed",
    CENTER_OPEN_CAN_BE_CLOSED = "center_open_can_be_closed",
    CENTER_CLOSING_CHECKLIST = "center_closing_checklist",
    CENTER_CLOSED = "center_closed",
}

const legacyToNewStateMap: Record<string, CenterOpenState> = {
    opening_checklist: CenterOpenState.CENTER_OPENING_CHECKLIST,
    open: CenterOpenState.CENTER_OPEN,
    closing: CenterOpenState.CENTER_OPEN_SERVICE_CLOSED,
    can_be_closed: CenterOpenState.CENTER_OPEN_CAN_BE_CLOSED,
    closing_checklist: CenterOpenState.CENTER_CLOSING_CHECKLIST,
    closed: CenterOpenState.CENTER_CLOSED,
}

export function normalizeCenterOpenState(newCenterStateValue: string): CenterOpenState {
    return legacyToNewStateMap[newCenterStateValue] ?? newCenterStateValue as CenterOpenState
}
